import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import Recommendation from '@/models/Recommendation.js'

export const useRecommendationStore = defineStore('recommendationStore', () => {
  let syncableModel = useSyncableModel(useApiResource('recommendations'), {
    className: Recommendation.modelName.name,
    paramKey: Recommendation.modelName.paramKey
  })

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    $reset
  }

}, {
  persist: true
})
